import { useContext } from 'react';
import { EventBusContext } from './EventBusContext';

const useEventBus = () => useContext(EventBusContext);

export default useEventBus;
